// Snapshot a DOM node into PNG / clipboard / PDF (html-to-image + jsPDF).
import { toPng, toJpeg, toBlob, toCanvas } from "html-to-image";
import { jsPDF } from "jspdf";

const OPTIONS = { pixelRatio: 2, cacheBust: true, backgroundColor: "#0b1220" };

const withFontFallback = async (fn) => {
  try {
    return await fn(OPTIONS);
  } catch {
    return fn({ ...OPTIONS, skipFonts: true });
  }
};

const slug = (s) => String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "").slice(0, 60);

export const downloadCardPng = async (node, title) => {
  const dataUrl = await withFontFallback((opts) => toPng(node, opts));
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = `license-hub-${slug(title)}.png`;
  a.click();
};

export const copyCardPng = async (node) => {
  const blob = await withFontFallback((opts) => toBlob(node, opts));
  if (!navigator.clipboard?.write || typeof ClipboardItem === "undefined") throw new Error("Clipboard images not supported in this browser");
  await navigator.clipboard.write([new ClipboardItem({ "image/png": blob })]);
};

export const downloadCardPdf = async (node, title) => {
  const dataUrl = await withFontFallback((opts) => toJpeg(node, { ...opts, quality: 0.92 }));
  const w = node.offsetWidth;
  const h = node.offsetHeight;
  const pdf = new jsPDF({ orientation: w >= h ? "landscape" : "portrait", unit: "px", format: [w, h], hotfixes: ["px_scaling"] });
  pdf.addImage(dataUrl, "JPEG", 0, 0, w, h, undefined, "FAST");
  pdf.save(`license-hub-${slug(title)}.pdf`);
};

// Multi-page A4 portrait PDF: the node is rasterised once and sliced into page-height strips.
export const downloadDocumentPdf = async (node, title) => {
  const canvas = await withFontFallback((opts) => toCanvas(node, opts));
  const pageW = 595;
  const pageH = 842;
  const scale = pageW / canvas.width;
  const sliceH = Math.floor(pageH / scale);
  const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  for (let y = 0, page = 0; y < canvas.height; y += sliceH, page += 1) {
    const h = Math.min(sliceH, canvas.height - y);
    const slice = document.createElement("canvas");
    slice.width = canvas.width;
    slice.height = h;
    const ctx = slice.getContext("2d");
    ctx.fillStyle = OPTIONS.backgroundColor;
    ctx.fillRect(0, 0, slice.width, slice.height);
    ctx.drawImage(canvas, 0, y, canvas.width, h, 0, 0, canvas.width, h);
    if (page > 0) pdf.addPage();
    pdf.setFillColor(11, 18, 32);
    pdf.rect(0, 0, pageW, pageH, "F");
    pdf.addImage(slice.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, pageW, h * scale, undefined, "FAST");
  }
  pdf.save(`license-hub-${slug(title)}.pdf`);
};
